import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID, ViewChild, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, NgForm, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule, MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ActivatedRoute, Router } from '@angular/router';
import { TablerIconsModule } from 'angular-tabler-icons';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { TarjetaComponent } from 'src/app/components/tarjeta/tarjeta.component';
import { PerfilService } from 'src/app/services/perfil.service';
import { TarjetaService } from 'src/app/services/tarjeta.service';
import { AuthService } from 'src/app/services/auth.service';
import { environment } from 'src/environments/environment';
import ClassicEditor from 'src/ckeditor5/build/ckeditor';
import { RegionService } from 'src/app/services/region.service';
import { ComunaService } from 'src/app/services/comuna.service';

@Component({
  selector: 'app-admin-card',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatTooltipModule,
    MatCardModule,
    MatInputModule,
    MatCheckboxModule,
    TablerIconsModule,
    NgxSpinnerModule,
    MatIconModule,
    MatTabsModule,
    MatTableModule,
    TarjetaComponent,
    CKEditorModule,
    MatSlideToggleModule,
    MatDatepickerModule,
    MatNativeDateModule,
  ],
  templateUrl: './admin-card.component.html',
  styleUrl: './admin-card.component.scss'
})
export class AdminCardComponent implements OnInit {

  isBrowser = false;
  public Editor: any = ClassicEditor;

  @ViewChild('form') form!: NgForm;
  @ViewChild('cardDialogTemplate') cardDialogTemplate!: TemplateRef<any>;
  color: string = '#1d934f';
  public toggle: boolean = false;
  profile: any = {};
  tarjeta: any = {};
  isEditMode = false;
  isTempClient = false; // Para clientes temporales (cliente 234)
  idCliente: string | null = '';
  perfiles: any[] = [];
  selectedPerfil: any;
  imgProfileFile?: File;

  isSportsClub = false;
  sportsData: any = {
    cargo: '',
    rut: '',
    fechaNacimiento: '',
    institucion: ''
  };

  isAdmin: boolean = false;
  isGlobalAdmin: boolean = false;
  hasMasterCard: boolean = false;
  masterCardEndDate: string = '';

  regiones: any[] = [];
  comunas: any[] = [];
  selectedRegionId: number | null = null;
  instruction: string = '';


  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private snackBar: MatSnackBar,
    private perfilService: PerfilService,
    private tarjetaService: TarjetaService,
    private authService: AuthService,
    private regionService: RegionService,
    private comunaService: ComunaService,
    private fb: FormBuilder,
    private dialog: MatDialog,
    @Inject(PLATFORM_ID) platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  async ngOnInit() {
    if (this.isBrowser) {
      const m = await import('src/ckeditor5/build/ckeditor');
      this.Editor = (m as any).default ?? (m as any).ClassicEditor ?? m;
    }

    if (!this.isBrowser) return;

    this.route.paramMap.subscribe(params => {
      const cardId = params.get('id');
      this.idCliente = params.get('icliente');
      const userProfile = this.authService.getProfileFromToken();
      // Detectar cliente temporal por perfil (4)
      this.isTempClient = userProfile === 4;
      this.isGlobalAdmin = userProfile === 1;
      this.isAdmin = userProfile === 1 || userProfile === 2;
      this.loadPerfiles();
      this.loadRegiones();
      this.isEditMode = !!cardId && cardId != "0";
      console.log(" this.isEditMode : " + this.isEditMode)
      if (this.isEditMode) {
        this.getProfile(cardId);
        this.getTarjeta(cardId);
      } else {
        this.initTarjeta();
      }
    });
  }


  loadPerfiles() {
    this.perfilService.getPerfiles(this.idCliente).subscribe({
      next: (response) => {
        this.spinner.hide();
        this.perfiles = response;
        if (this.tarjeta) {
          this.selectedPerfil = this.tarjeta.idPerfil;
        }
      },
      error: (err) => {
        this.spinner.hide();
        console.error('Error al cargar el perfil:', err);
      },
    });
  }

  onPerfilChange(): void {
    const perfilEncontrado = this.perfiles.find(perfil => perfil.id === Number(this.selectedPerfil));
    this.tarjeta.idPerfil = this.selectedPerfil;
    this.profile = perfilEncontrado;
    this.profile = { ...this.profile };
  }

  initTarjeta() {
    const fechaActual = new Date();
    const fechaFutura = new Date(fechaActual);
    fechaFutura.setDate(fechaFutura.getDate() + 365);

    // Check if client already has a master card
    if (this.idCliente && !this.isTempClient) {
      this.tarjetaService.getMasterCardInfo(this.idCliente).subscribe({
        next: (res) => {
          this.hasMasterCard = res.hasMasterCard;
          if (this.hasMasterCard && res.masterEndDate) {
            this.masterCardEndDate = res.masterEndDate;
            this.tarjeta.endDate = this.masterCardEndDate; // Inherit the date
          }
        },
        error: (err) => console.error("Could not fetch master card info", err)
      });
    }

    this.tarjeta = {
      id: null,
      uid: null,
      idPerfil: null,
      imgProfile: environment.apiEndpoint + "images/1.jpg",
      imgProfileResize: '',
      nombre: '',
      cargo: '',
      telefono: this.isAdmin ? '+569' : '',
      wsp: this.isAdmin ? '+569' : '',
      correo: '',
      direccion: '',
      linkProfile: '',
      showRSComponent: false,
      redes: [],
      showChatboot: false,
      urlChatboot: '',
      endDate: fechaFutura.toISOString()
    };
    this.isSportsClub = false;
    this.sportsData = {
      cargo: '',
      rut: '',
      fechaNacimiento: '',
      institucion: ''
    };
  }

  getTarjeta(cardId) {
    this.spinner.show();
    this.tarjetaService.getTarjetaById(cardId).subscribe({
      next: (response) => {
        this.spinner.hide();
        this.tarjeta = {
          ...response,
          telefono: response.telefono || (this.isAdmin ? '+569' : ''),
          wsp: response.wsp || (this.isAdmin ? '+569' : ''),
        };
        this.tarjeta.showRSComponent = !!this.tarjeta.showRSComponent;
        this.tarjeta.redes = this.tarjeta.redes || [];
        this.tarjeta.showChatboot = !!this.tarjeta.showChatboot;
        this.tarjeta.urlChatboot = this.tarjeta.urlChatboot || '';
        this.selectedPerfil = this.tarjeta.idPerfil;
        this.preloadRegionComunaFromTarjeta();

        if (this.tarjeta.cargo && this.tarjeta.cargo.includes('[SPORTS_CLUB]')) {
          this.isSportsClub = true;
          try {
            const parts = this.tarjeta.cargo.split('[SPORTS_CLUB]');
            if (parts.length > 1) {
              const jsonStr = parts[1].trim();
              this.sportsData = JSON.parse(jsonStr);
            }
          } catch (e) {
            console.error("Error parsing sports club data", e);
            this.isSportsClub = false;
          }
        }
      },
      error: (err) => {
        this.spinner.hide();
        console.error('Error al cargar la tarjeta:', err);
      },
    });
  }

  getProfile(cardId) {
    this.perfilService.getPerfilByIdTarjeta(cardId).subscribe({
      next: (response) => {
        this.spinner.hide();
        this.profile = response;
      },
      error: (err) => {
        this.spinner.hide();
        console.error('Error al cargar el perfil:', err);
      },
    });
  }


  guardarTarjeta(openCard: boolean = false) {
    if (this.form.invalid) return;

    if (!this.tarjeta?.idComuna) {
      this.snackBar.open('Debes seleccionar una comuna para guardar la tarjeta.', 'Cerrar', { duration: 3500 });
      return;
    }

    // Pre-open window if needed to avoid popup blockers (especially iOS)
    let newWindow: Window | null = null;
    if (openCard) {
      newWindow = window.open('', '_blank');
    }

    if (this.isSportsClub) {
      this.tarjeta.cargo = '[SPORTS_CLUB]' + JSON.stringify(this.sportsData);
    }
    this.tarjeta.endDate = this.tarjeta.endDate || this.defaultEndDate();
    this.normalizeCardSocials();

    const tarjetaEdit = new FormData();
    tarjetaEdit.append('tarjeta', JSON.stringify(this.tarjeta));

    if (this.imgProfileFile) {
      tarjetaEdit.append('imgProfile', this.imgProfileFile);
    }

    if (this.isEditMode) {
      //update
      this.spinner.show();
      this.tarjetaService.updateTarjeta(tarjetaEdit).subscribe({
        next: (data) => {
          this.spinner.hide();
          this.snackBar.open(data.msg, 'Cerrar', { duration: 3000 });
          this.afterSave(openCard, newWindow);
        },
        error: (err) => {
          console.error('Error al editar la Tarjeta:', err);
          this.spinner.hide();
          if (newWindow) newWindow.close();
          const errorMessage = err?.error?.message || err?.error || 'Error al editar la Tarjeta.';
          this.snackBar.open(typeof errorMessage === 'string' ? errorMessage : 'Error al editar la Tarjeta.', 'Cerrar', { duration: 5000 });
        },
      });
    } else {
      //insert
      this.spinner.show();
      this.tarjetaService.createTarjeta(tarjetaEdit).subscribe({
        next: (data) => {
          this.spinner.hide();
          this.snackBar.open(data.msg, 'Cerrar', { duration: 3000 });
          this.afterSave(openCard, newWindow);
        },
        error: (err) => {
          console.error('Error al crear la Tarjeta:', err);
          this.spinner.hide();
          this.snackBar.open('Error al crear la Tarjeta.', 'Cerrar', { duration: 3000 });
          if (newWindow) newWindow.close();
        },
      });
    }
  }

  afterSave(openCard: boolean = false, newWindow: Window | null = null): void {
    if (this.isTempClient) {
      if (newWindow) newWindow.close();
      this.instruction = '';
      this.dialog.open(this.cardDialogTemplate, {
        width: '450px',
        maxWidth: '95vw',
        panelClass: 'custom-dialog-container',
        disableClose: true
      });
    } else {
      if (newWindow && !openCard) {
        newWindow.close();
      }
      this.volver();
    }
  }

  verTarjeta(newWindow: Window | null = null): void {
    if (this.tarjeta?.uid) {
      const url = this.router.serializeUrl(
        this.router.createUrlTree(['/tarjeta', this.tarjeta.uid])
      );

      if (newWindow) {
        newWindow.location.href = url;
      } else {
        // Fallback or if opened without pre-window (shouldn't happen with current logic for 'openCard')
        window.open(url, '_blank');
      }
    } else {
      if (newWindow) newWindow.close();
    }
  }

  onFileChange(event: Event, controlName: string): void {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length > 0) {
      const file = input.files[0];

      if (!file.type.startsWith('image/')) {
        alert('Por favor, selecciona un archivo de imagen válido.');
        input.value = '';
        return;
      }

      // Check if file size > 2MB
      const maxSizeInBytes = 2 * 1024 * 1024; // 2MB
      if (file.size > maxSizeInBytes) {
        this.snackBar.open('Comprimiendo imagen...', 'Cerrar', { duration: 2000 });
        this.compressImage(file).then(compressedFile => {
          if (compressedFile.size > maxSizeInBytes) {
            this.snackBar.open('La imagen es demasiado pesada incluso después de comprimir. Intente con otra.', 'Cerrar', { duration: 4000 });
            input.value = '';
            return;
          }
          this.handleFile(compressedFile, controlName);
        }).catch(err => {
          console.error("Error compression:", err);
          this.snackBar.open('Error al procesar la imagen.', 'Cerrar', { duration: 3000 });
        });
      } else {
        this.handleFile(file, controlName);
      }
    }
  }

  handleFile(file: File, controlName: string) {
    this.imgProfileFile = file;
    const reader = new FileReader();
    reader.onload = () => {
      if (controlName === 'img') {
        this.tarjeta.imgProfile = reader.result;
      }
    };
    reader.readAsDataURL(file);
  }

  compressImage(file: File): Promise<File> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (event: any) => {
        const img = new Image();
        img.src = event.target.result;
        img.onload = () => {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');

          // Max dimensions
          const maxWidth = 800; // Reduced from 1280
          const maxHeight = 800; // Reduced from 1280
          let width = img.width;
          let height = img.height;

          if (width > height) {
            if (width > maxWidth) {
              height *= maxWidth / width;
              width = maxWidth;
            }
          } else {
            if (height > maxHeight) {
              width *= maxHeight / height;
              height = maxHeight;
            }
          }

          canvas.width = width;
          canvas.height = height;
          ctx?.drawImage(img, 0, 0, width, height);

          canvas.toBlob((blob) => {
            if (blob) {
              const compressedFile = new File([blob], file.name, {
                type: 'image/jpeg',
                lastModified: Date.now(),
              });
              resolve(compressedFile);
            } else {
              reject(new Error('Canvas to Blob failed'));
            }
          }, 'image/jpeg', 0.6); // 0.6 quality (Reduced from 0.7)
        };
        img.onerror = (err) => reject(err);
      };
      reader.onerror = (err) => reject(err);
    });
  }


  updateCard() {
    this.tarjeta = { ...this.tarjeta };
  }

  toggleChangedRSComponent(newValue: boolean) {
    this.tarjeta = { ...this.tarjeta, showRSComponent: newValue };
  }

  addRedSocial() {
    if (!this.tarjeta.redes) {
      this.tarjeta.redes = [];
    }
    this.tarjeta.redes.push({ tipo: 'facebook', link: '', iconClass: this.getSocialIconClass('facebook') });
    this.normalizeCardSocials();
  }

  removeRedSocial(index: number) {
    this.tarjeta.redes.splice(index, 1);
    this.normalizeCardSocials();
  }

  normalizeCardSocials() {
    this.tarjeta.redes = (this.tarjeta.redes || []).map(red => ({
      ...red,
      iconClass: this.getSocialIconClass(red.tipo)
    }));
    this.tarjeta = { ...this.tarjeta };
  }

  getSocialIconClass(tipo: string): string {
    const iconMap: { [key: string]: string } = {
      facebook: 'fab fa-facebook-f',
      instagram: 'fab fa-instagram',
      twitter: 'fa-brands fa-x-twitter',
      linkedin: 'fab fa-linkedin-in',
      youtube: 'fab fa-youtube',
      tiktok: 'fab fa-brands fa-tiktok',
      promo: 'fas fa-bullhorn'
    };
    return iconMap[tipo] || 'fas fa-link';
  }

  onCargoChange(value: string) {
    this.tarjeta = { ...this.tarjeta, cargo: value };
  }


  volver(): void {
    if (this.isTempClient) {
      this.router.navigate(['/client/beneficios']);
    } else {
      this.router.navigate(['/admin-client', this.idCliente]);
    }
  }

  loadRegiones() {
    this.regionService.getRegiones().subscribe({
      next: (response) => {
        this.regiones = response || [];
      },
      error: (err) => {
        console.error('Error al cargar regiones:', err);
      },
    });
  }

  preloadRegionComunaFromTarjeta() {
    const comunaId = this.tarjeta?.idComuna ?? this.tarjeta?.comuna?.id;
    if (!comunaId) {
      return;
    }

    this.comunaService.getComunaById(comunaId).subscribe({
      next: (comuna) => {
        const regionId = comuna?.idRegion ?? comuna?.region?.id;
        if (!regionId) {
          return;
        }
        this.selectedRegionId = Number(regionId);
        this.onRegionChange(this.selectedRegionId, true);
        this.tarjeta.idComuna = Number(comunaId);
      },
      error: (err) => {
        console.error('Error al cargar comuna asociada:', err);
      },
    });
  }

  onRegionChange(regionId: number | null, keepComunaSelection: boolean = false) {
    this.selectedRegionId = regionId ? Number(regionId) : null;
    this.comunas = [];

    if (!this.selectedRegionId) {
      if (!keepComunaSelection) {
        this.tarjeta.idComuna = null;
      }
      return;
    }

    this.comunaService.getComunasByRegion(this.selectedRegionId).subscribe({
      next: (response) => {
        this.comunas = response || [];
        if (keepComunaSelection) {
          const exists = this.comunas.some(c => Number(c.id ?? c.idComuna) === Number(this.tarjeta.idComuna));
          if (!exists) {
            this.tarjeta.idComuna = null;
          }
          return;
        }
        this.tarjeta.idComuna = null;
      },
      error: (err) => {
        console.error('Error al cargar comunas por región:', err);
        this.comunas = [];
        if (!keepComunaSelection) {
          this.tarjeta.idComuna = null;
        }
      },
    });
  }

  updateSportsCargo() {
    if (this.isSportsClub) {
      this.tarjeta.cargo = '[SPORTS_CLUB]' + JSON.stringify(this.sportsData);
    } else {
      // If turned off, clean the cargo if it contains JSON to avoid showing it in CKEditor
      if (this.tarjeta.cargo && this.tarjeta.cargo.includes('[SPORTS_CLUB]')) {
        this.tarjeta.cargo = this.sportsData.cargo || '';
      }
    }
    this.tarjeta = { ...this.tarjeta }; // Trigger change detection for preview
  }

  validatePhone(phone: string): boolean {
    if (!phone) return true; // Si es obligatorio ya lo valida el form, si es opcional dejalo pasar
    if (!this.isAdmin) {
      // Must start with +56 9 if not admin
      const cleanPhone = phone.trim();
      return cleanPhone.startsWith('+56 9') || cleanPhone.startsWith('+569');
    }
    return true;
  }

  showInstruction(platform: string) {
    this.instruction = platform;
  }

  cerrarDialogo() {
    this.dialog.closeAll();
    this.verTarjeta();
  }

  private defaultEndDate(): string {
    const endDate = new Date();
    endDate.setFullYear(endDate.getFullYear() + 1);
    return endDate.toISOString();
  }
}
